import { render, staticRenderFns } from "./ChangeLogModal.vue?vue&type=template&id=58069a83&"
import script from "./ChangeLogModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports